import PropTypes from 'prop-types'

export default {
  input: PropTypes.object,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  labelComponent: PropTypes.node,
  errorComponent: PropTypes.node,
  disabled: PropTypes.bool,
  radioValue: PropTypes.string,
  selected: PropTypes.bool,
  value: PropTypes.string,
  slim: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  bold: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/forms/fieldProps.js